// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"d588e96e","249":"d588e96e","369":"d588e96e","870":"c2aae9b3","919":"d588e96e"}[chunkId] + ".css";
};